<div class="modal-header">
  <h3 class="modal-title" i18n="@@TicketConditions">Ticket Conditions</h3>
  <button
    type="button"
    class="light-icon-button close"
    aria-label="Close Ticket Conditions Modal"
    (click)="close()"
    ngbAutoFocus
  >
    <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
  </button>
</div>
<div class="modal-body" tabindex="0">
  @if (ticketIsObject && ticketDetails) {
    <ul class="modal-list">
      @for (detail of ticketConditionsOrdered; track detail) {
        @if (detail.value) {
          <li
            class="modal-list-item"
            [ngClass]="{ 'ticket-name': detail.key === 'ticketTypeName' }"
          >
            <span class="rule-title">{{ detail.key | translate | titlecase }}</span>
            <span class="rule-value" [innerHTML]="detail.value"></span>
          </li>
        }
      }

      @if (includedExtras?.length) {
        <li class="modal-list-item">
          <span class="rule-title" i18n="@@trainlineFreeExtras">Free extras</span>
          <span class="rule-value">
            @for (extras of includedExtras; track extras) {
              <div>{{ extras }}</div>
            }
          </span>
        </li>
      }
    </ul>
  } @else if (ticketDetails) {
    <ul class="modal-list">
      @for (detail of ticketDetails; track detail) {
        @if (detail.value) {
          <li
            class="modal-list-item"
            [ngClass]="{ 'ticket-name': detail.key === 'ticketTypeName' }"
          >
            <span class="rule-title">{{ detail.key | translate | titlecase }}</span>
            <span class="rule-value" [innerHTML]="detail.value"></span>
          </li>
        }
      }

      @if (includedExtras?.length) {
        <li class="modal-list-item">
          <span class="rule-title" i18n="@@trainlineFreeExtras">Free extras</span>
          <span class="rule-value">
            @for (extras of includedExtras; track extras) {
              <div>{{ extras }}</div>
            }
          </span>
        </li>
      }
    </ul>
  } @else {
    <span>No data to display</span>
  }
</div>
<div class="modal-footer">
  <button type="button" title="Ok" appButton="small" (click)="close()">Ok</button>
</div>
